import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

const CustomTextField = ({ suffix, ...props }) => {
  return (
    <TextField
      {...props}
      InputProps={{
        ...props.InputProps,
        endAdornment: suffix ? (
          <InputAdornment position="end">{suffix}</InputAdornment>
        ) : null,
      }}
    />
  );
};

export default CustomTextField;
